export const SET_GUID = 'TRACKING/SET_GUID';
export const HIDE_BRANCHES_CTA = 'TRACKING/HIDE_BRANCHES_CTA';
